import { useSearchParams } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import Container from '@/components/base/Container';
import Eyebrow from '@/components/base/Eyebrow';
import BookingForm from './components/BookingForm';

export default function BookPage() {
  const [params] = useSearchParams();

  return (
    <PageShell>
      <section className="bg-background-100 py-14 md:py-24">
        <Container>
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
            <div className="lg:col-span-4">
              <Eyebrow label="Book a Repair" />
              <h1 className="mt-6 text-[38px] md:text-[52px] font-medium leading-[1.02] tracking-[-0.03em] text-foreground-950">Request a Repair Visit.</h1>
              <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-foreground-600">
                Four short steps. Tell us what&apos;s wrong and when suits you best.
              </p>
              <div className="mt-8 rounded-lg border border-accent-300 bg-accent-50 p-5">
                <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.12em] text-accent-900">
                  <i className="ri-information-line" /> Please note
                </p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  Submitting this form sends an appointment request. Your visit is confirmed only after MENDWELL reviews it and contacts you.
                </p>
              </div>
            </div>
            <div className="lg:col-span-8 min-w-0">
              <BookingForm key={params.get('appliance') ?? 'none'} initialAppliance={params.get('appliance') ?? ''} />
            </div>
          </div>
        </Container>
      </section>
    </PageShell>
  );
}